import type { ReactNode } from 'react';
import React from 'react';

import { Box } from '@mui/material';

import AddApp from '@/assets/icons/AddApp';
import Typography from '@/components/Typography';

export const DrawerHeader = ({
  before,
  title,
  buttons
}: {
  before?: ReactNode;
  title: string;
  buttons: ReactNode;
}) => (
  <Box
    sx={{
      borderBottom: '1px solid #6C737A',
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      backgroundColor: 'background.default',
      pl: before ? 0 : 3
    }}
  >
    {before}
    <AddApp
      fill='#F8F8F8'
      sx={{
        width: '32px',
        height: '32px'
      }}
    />
    <Typography
      size={24}
      sx={{ fontWeight: 'bold', mr: 2, py: 3 }}
    >
      {title}
    </Typography>
    <Box
      sx={{
        ml: 'auto',
        display: 'flex',
        gap: '2px',
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '100%'
      }}
    >
      {buttons}
    </Box>
  </Box>
);
